const Shapefile_projections = [{country:"Peru", projection:"geoMercator"}]

const Shapefiles_Peru = [
    {id:["Peru"], url:"https://raw.githubusercontent.com/juaneladio/peru-geojson/master/peru_departamental_simple.geojson",subregion_key:["properties", "NOMBDEP"]},
    {id:["Peru","Provinces"], url:"https://raw.githubusercontent.com/juaneladio/peru-geojson/master/peru_provincial_simple.geojson", subregion_key:["properties", 'NOMBPROV']},
    {id:["Peru","Districts"], url:"https://raw.githubusercontent.com/juaneladio/peru-geojson/master/peru_distrital_simple.geojson", subregion_key:["properties", 'NOMBDIST']}
]

export {Shapefile_projections, Shapefiles_Peru};